<div>
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div>
    <ag-grid-angular style="width: 100%; height: 100%" class="ag-theme-alpine" rowSelection="multiple" rowHeight="48" rowMultiSelectWithClick="false"
      suppressRowClickSelection="true" suppressDragLeaveHidesColumns="true" suppressMenuHide="true" enableCellTextSelection="true" [icons]="customIcons"
      [columnDefs]="columnDefs" [tooltipShowDelay]="500" [defaultColDef]="defaultColDef" [paginationPageSize]="paginationPageSize" [pagination]="true"
      [suppressPaginationPanel]="true" [suppressCellSelection]="true" [getMainMenuItems]="getMainMenuItems" [suppressScrollOnNewData]="true" [rowData]="rowData"
      [domLayout]="domLayout" (columnMoved)="onColumnMoved($event)" [getContextMenuItems]="getContextMenuItems" (columnResized)="onColumnResized($event)"
      (columnVisible)="onColumnVisible($event)" (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>

  <div class="d-flex justify-content-between align-items-center my-15 has-pagination">
    <div class="pagination-left">
      <app-pagination *ngIf="totalRowsCount > paginationPageSize" [totalItems]="totalRowsCount" [(currentPage)]="currentPageNumber"
        (change)="onPageChange($event)" [pageSize]="paginationPageSize"></app-pagination>
    </div>

    <div class="d-flex align-items-center justify-content-end pagination-right">
      <span class="pagination-count">Showing {{ totalRowsCount > paginationPageSize ? paginationPageSize  : totalRowsCount }} of {{ totalRowsCount }}
        results</span>
      <ul *ngIf="sizes.length" class="pagination">
        <li *ngFor="let size of sizes" [ngClass]="{ active: size === paginationPageSize }">
          <a (click)="changeSize($event, size)">{{ size }}</a>
        </li>
      </ul>
    </div>
  </div>
</div>

<ng-template #detailsModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test Details</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="details" class="spinner">
      <div class="sk-spinner sk-spinner-pulse small"></div>
    </div>
    <div class="details-pane mb-25">
      <table *ngIf="details && details.test" class="table table-test" style="margin: 0;">
        <tr>
          <td class="detail-title"><strong>ID</strong></td>
          <td class="detail-body"><code>{{ details.test.id }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>Test group ID</strong></td>
          <td class="detail-body"><code>{{ details.test.testGroupId }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>Text</strong></td>
          <td class="detail-body"><code>{{ details.test.textDelivered }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>Origination</strong></td>
          <td class="detail-body"><code>{{ details.test.originDto.phone }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>Destination</strong></td>
          <td class="detail-body"><code>{{ details.test.destination }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>Status (Sent/DLR)</strong></td>
          <td class="detail-body"><code>{{ details.test.sentStatus }} / {{ details.test.dlrStatus }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>TTL</strong></td>
          <td class="detail-body"><code>{{ details.ttl | duration }}</code></td>
        </tr>
        <tr>
          <td class="detail-title"><strong>IP</strong></td>
          <td class="detail-body"><code>{{ details.callerIp ? details.callerIp : 'n/a' }}</code></td>
        </tr>
      </table>
    </div>
    <hr *ngIf="details">
    <table *ngIf="details" class="table mb-25">
      <tbody>
        <tr>
          <th>Type</th>
          <th>Device time</th>
          <th>Server time</th>
          <th>Status (Code)</th>
          <th>Status (Description)</th>
        </tr>
        <tr *ngIf="!details.statuses.length">
          <td colspan="5">
            <div *ngIf="!details.statuses.length" class="text-muted text-center">Status history is empty</div>
          </td>
        </tr>
        <ng-container *ngFor="let status of details.statuses">
          <tr>
            <td>
              <i *ngIf="status.isStatusAfterExpired" class="fa fa-exclamation-circle text-warning" title="Status received after TTL"></i>
              <span>
                {{ status.isDlr ? 'DLR' : 'SENT' }} ({{ status.segmentNumber }}/{{ status.totalNumberOfSegments }})
              </span>
            </td>
            <td><span [title]="status.phoneTimestamp | date:'y-MM-dd HH:mm:ss (UTC)':'UTC'">{{ status.phoneTimestamp | date: 'y-MM-dd HH:mm:ss' }}</span>
            </td>
            <td><span [title]="status.serverReceivedAt | date:'y-MM-dd HH:mm:ss (UTC)':'UTC'">{{ status.serverReceivedAt | date: 'y-MM-dd HH:mm:ss'}}</span>
            </td>
            <td>
              <ng-template *ngIf="status.codeReferenceLink; then link else noLink"></ng-template>
              <ng-template #link>
                <a class="status-desc-link" target="_blank" [href]="status.codeReferenceLink">{{ status.statusDescription }} ({{
                  status.statusCode }})</a>
              </ng-template>
              <ng-template #noLink>
                {{ status.statusDescription }} ({{ status.statusCode }})
              </ng-template>
              <button *ngIf="status.pdu" type="button" class="btn btn-sm btn-primary pdu-button" (click)="onClickPdu(status)">PDU</button>
            </td>
            <td>
              {{status.codeDescription}}
            </td>
          </tr>
          <tr *ngIf="status.showPdu">
            <td colspan="5">
              <textarea class="form-control" readonly [value]="status.pdu" style="max-width: 100%;resize: vertical;" rows="5"></textarea>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #reimburseModalTpl let-dialogRef="dialogRef">
  <confirm-modal [dialogRef]="dialogRef"></confirm-modal>
</ng-template>
